import {
  DATA_SOURCE_KEY_MAPPING,
  getDataSourceByKey,
  SMART_PAGE_DEFAULT_VALUES,
} from '@bingads-webui-campaign-react/smart-component-util';

import { dataProperties } from './data-config';

// Currently header editor is integrated in introduction section
export const proxyReadHeaderComponentConfig = (componentConfig, siteConfig, i18n) => {
  const { [dataProperties.logo]: logo } = componentConfig;

  const businessName = getDataSourceByKey(siteConfig, DATA_SOURCE_KEY_MAPPING.BusinessName);

  return {
    businessName,
    defaultBusinessName: i18n.getString(SMART_PAGE_DEFAULT_VALUES.BUSINESS_NAME),
    logo: logo || {},
  };
};
